import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import './Profiles.css';
import {Error404} from '../error404/Error404';

import {AnalogueAttic} from './labelsFolder/AnalogueAttic';
import {Church} from './labelsFolder/Church';

import {SoulClap} from './newsFolder/SoulClap';

export const Profiles = () => {

	return(
		<Router>
			<section className='profilesContainer'>
				<Switch>
					<Route path='/profile/analogue_attic' component={AnalogueAttic} exact />
					<Route path='/profile/church' component={Church} exact />
					<Route path='/profile/soul_clap' component={SoulClap} exact />
					<Route path='/404' component={Error404} />
         	 		<Redirect to='/404' />
				</Switch>
			</section>
		</Router>
	)
}